import clsx from "clsx";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { FC, useState } from "react";

import { IconButton } from "../../buttons/icon-button";
import { Modal } from "../../modal";
import { BannerGridProps } from "./banner-grid";
import { BannerGridImageFitTypes } from "./types";

export type BannerGridImageProps = Pick<
  BannerGridProps,
  "image" | "enableImageZoom" | "title" | "imageFit"
>;

export const BannerGridImage: FC<BannerGridImageProps> = ({
  image,
  imageFit,
  enableImageZoom,
  title,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      {image?.gatsbyImageData && (
        <GatsbyImage
          image={image?.gatsbyImageData}
          alt={title ?? ""}
          objectFit={imageFit === BannerGridImageFitTypes.COVER ? "cover" : "contain"}
          className={clsx("w-full h-full !absolute", {
            "bg-light": imageFit === BannerGridImageFitTypes.CONTAIN_BG_WHITE,
            "bg-primary": imageFit === BannerGridImageFitTypes.CONTAIN_BG_PRIMARY,
            "bg-transparent": imageFit === BannerGridImageFitTypes.CONTAIN_BG_TRANSPARENT,
          })}
        />
      )}
      {image?.gatsbyImageData && enableImageZoom && (
        <IconButton
          icon="zoom-in"
          variant="primary-overlay"
          size="large"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          onClick={() => setModalOpen(true)}
        />
      )}
      {enableImageZoom && image?.gatsbyImageData && (
        <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
          <GatsbyImage image={image.gatsbyImageData} alt={title ?? ""} objectFit="contain" />
        </Modal>
      )}
    </>
  );
};
